import { useParams, Link } from 'react-router-dom';
import { CATEGORIES, getByCategory } from '@/data/templates';
import TemplateCard from '@/components/TemplateCard';
import * as Icons from 'lucide-react';

export default function Category() {
  const { slug } = useParams();
  const cat = CATEGORIES.find(c => c.slug === slug);
  const templates = getByCategory(slug);
  const Icon = cat ? (Icons[cat.icon] || Icons.Folder) : Icons.Folder;

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <Link to="/" className="text-sm text-stone-500 hover:text-orange-600 flex items-center gap-1 mb-6" data-testid="back-home">
        <Icons.ArrowLeft size={14} /> Back to home
      </Link>
      <div className="flex items-center gap-4 mb-10">
        <div className={`w-14 h-14 rounded-2xl grid place-items-center ${cat?.tint || 'bg-stone-100 text-stone-700'}`}>
          <Icon size={22} />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-stone-500">Category</div>
          <h1 className="font-display font-bold text-4xl tracking-tight">{cat?.name || 'Templates'}</h1>
        </div>
      </div>

      {templates.length === 0 ? (
        <p className="text-stone-500">No templates yet in this category.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {templates.map(t => <TemplateCard key={t.id} template={t} />)}
        </div>
      )}
    </div>
  );
}
